import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { MyContextProvider } from "./context/credentialContext";
import { LoadingProvider, useLoading } from "./context/LoadingContext";
import { Toaster } from "react-hot-toast";
import SmoothScroll from "./components/SmoothScroll";
import Loading from "./components/Loading";

import Home from "./pages/Home";
import ProductPage from "./pages/ProductPage";
// import Cart from "./pages/Cart";
import TicketPage from "./pages/TicketPage";
import Merch from "./pages/Merch";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Checkout from "./pages/CheckOut";
import VendorPayment from "./pages/Vendor";
import { useEffect } from "react";

function VendorRedirect() {
  useEffect(() => {
    window.location.href =
      "https://docs.google.com/forms/d/e/1FAIpQLSdGrvBZi-KlnlG0bZlfZwHLD3e4-pCHAxZSpiKqMkB1q6AeVw/viewform?usp=sf_link";
  }, []);
}

function AppContent() {
  const { isLoading } = useLoading();

  return (
    <>
      <Loading />
      <div
        className={`transition-opacity duration-1000 ease-in ${
          isLoading ? "opacity-0" : "opacity-100"
        }`}
      >
        <Router>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<ProductPage />} />
              {/* <Route path="/cart" element={<Cart />} /> */}
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/tickets" element={<TicketPage />} />
              <Route path="/merch" element={<Merch />} />
              <Route path="/merch/:slug" element={<ProductPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/vendor" element={<VendorRedirect />} />
              <Route path="/vendorpayment" element={<VendorPayment />} />
            </Routes>
          </SmoothScroll>
        </Router>
      </div>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <MyContextProvider>
      <LoadingProvider>
        <AppContent />
      </LoadingProvider>
    </MyContextProvider>
  );
}

export default App;
